import { Validator } from 'vee-validate';

Validator.extend('esMenorQue', (value, [otherValue]) => {
    return value >= otherValue;
}, {
    hasTarget: true
});


// WEBPACK FOOTER //
// ./src/services/validator.js